import * as Commands from '../lib/commands'
import * as EWay from './eway-external'
import * as PaymentMethodsTabs from './payment-methods-tabs'
import * as ScheduledPayments from './scheduled-payments'
import * as creditcard from "./credit-card"
import * as ReusablePayer from "./reusable-payer"

type EwayAccessCodeRequestResult = {
	AccessCode: string
	FormActionURL: string
}

type AccessCodeRequestResponse = {
	Code?: EwayAccessCodeRequestResult
	Continue?: string
}

class EwayTools {
	private caller:Commands.CommandCaller;

	constructor(ajaxPageUrl:string) {
		this.caller = new Commands.CommandCaller(ajaxPageUrl)
	}

	requestAccessCode(creditCardType:string):Promise<AccessCodeRequestResponse> {
		return this.caller.runPost('eway.request access code', {
			cardType: creditCardType
		}) as Promise<AccessCodeRequestResponse>
	}

	submitPayment(ewayRequestResult:EwayAccessCodeRequestResult, params:CreditCardParams):Promise<EWay.Result> {
		return EWay.processEway({
			Name:          params.name,
			Number:        params.number,
			Month:         params.month,
			Year:          params.year,
			CVV:           params.cvv,
			FormActionURL: ewayRequestResult.FormActionURL,
			AccessCode:    ewayRequestResult.AccessCode
		}).then((ewayResult:EWay.Result) => {
			if (ewayResult.Is3DSecure) {
				window.location.replace(ewayResult.RedirectUrl)
			}
			return ewayResult
		})
	}

	submitSuccess(ewayResult:EWay.Result):Promise<void> {
		return (this.caller.runPost('eway.submit success', {
			code: ewayResult.AccessCode
		}) as Promise<{nextPage: string}>).then((result:{nextPage: string}) => {
			window.location.assign(result.nextPage)
		})
	}
}

//noinspection JSUnusedGlobalSymbols
export const submitEwayPayment = (div:JQuery, ajaxPageUrl:string) => {
	const eway   = new EwayTools(ajaxPageUrl)
	const params = creditcard.getCreditCardParams()
	div.block({message: "Please wait while we attempt to process your payment..."})

	const handleError = (str: string) => (e:any) => {
		console.log(e, "the error message", str)
		window.alert("An error has occurred")
		div.unblock()
	}

	if (params.cardType === "unknown") {
		handleError("unknown card")("The credit card number you have entered is unknown or not supported")
		return
	}

	const withAccessCode = (result:AccessCodeRequestResponse) => {
		if (typeof result.Code !== "undefined") {
			eway.submitPayment(result.Code, params).then(
				(r) => eway.submitSuccess(r).catch(handleError("eway submit success")),
				handleError("eway sbumit payment")
			)
		} else if (typeof result.Continue !== "undefined") {
			window.location.assign(result.Continue)
		} else {
			handleError("with access code")("There was a system error processing your order. It is safe to resubmit.")
		}
	}

	eway.requestAccessCode(params.cardType).then(
		withAccessCode,
		handleError("request access code")
	)
}

export const paymentMethodsTabs = PaymentMethodsTabs
export const scheduledPayments = ScheduledPayments
export const creditCard = creditcard
export const reusablePayer = ReusablePayer



// WEBPACK FOOTER //
// ./src/paymentgateway/paymentgateway.ts